
export class UserEntity{ 
id: string;
name: string;
email: string;
password: string;
}